<div class="col-sm-12 coldx" >
	<h4>{{title}}</h4>
	<ng-template [ngIf]="contributoUnificatoForm">
		<form [formGroup]="contributoUnificatoForm" (ngSubmit)="save();">
			<div class="container_dati_generali">
				<table class="fondo_rischi">
					<caption class="sr-only">Tabella tipi contributo unificato</caption>
					<ng-template ngFor let-tipoContributoUnificato [ngForOf]="tipiContributoUnificato">
						<tr class="borded">
							<td>
									<p class="active singlecheckbox radiobutton">
										<input [name]="'tipoContributoUnificato'" id="{{ tipoContributoUnificato.id }}"
										value="{{ tipoContributoUnificato.id }}" type="radio"
										[(ngModel)]="request.tipoContributo"
										formControlName="tipoContributoUnificato"
										[checked]="isTipoContributoUnificatoSelected(tipoContributoUnificato.id)"/>
										<label for="{{tipoContributoUnificato.id}}" (click)="setTipoContributoUnificato(tipoContributoUnificato)">{{ tipoContributoUnificato.label }} </label>
									</p>
							</td>
							<td>
								<div [ngSwitch]="tipoContributoUnificato.id">
									<div *ngSwitchCase="'ESENZIONE'"></div>
									<div *ngSwitchCase="'IMPORTO'">
										<div textInputCurrency class="form-group"
											[control]="contributoUnificatoForm.controls['importo']"
											[labelInput]="'Importo'" [location]="'SezioneEconomica'"
											[(ngModel)]="request.valoreImportoFisso"
											(onReturn)="request.valoreImportoFisso = $event"
											(onModelChange)="onChangeImportoFisso($event)"
											[mandatory]="isTipoContributoUnificatoSelected('IMPORTO')"
											[submitPending]="!isTipoContributoUnificatoSelected('IMPORTO')"
											formControlName="importo"></div>
									</div>
									<div *ngSwitchCase="'SCAGLIONE'">
									</div>
									<div *ngSwitchCaseDefault></div>
								</div>
							</td>
						</tr>
					</ng-template>
				</table>
			</div>

			<div class="row" *ngIf="!isTipoContributoUnificatoSelected('ESENZIONE')">
				<div comboModInput [labelInput]="'Applicazione aumento/riduzione'"
				class="col-sm-6"
				[labelNoSelection]="'Nessuna'"
				(onReturn)="onChangeScaglione($event)"
				[optionsCombo]="scaglioneContributoUnificatoOptions"
				[objectReference]="scaglioneContributoUnificatoSelected"></div>
			</div>

			<div class="row">
				<p class="mandatory col-sm-12">
					<em>* Campi obbligatori</em>
				</p>
			</div>

			<div class="row">
				<div class="col-sm-3 col-xs-6">
					<p>
						<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset
						</button>
					</p>
				</div>
				<div class="col-sm-3 col-xs-6 col-sm-offset-6">
					<p submitButton [labelButton]="'Salva'" [disabled]="contributoUnificatoForm.invalid || !importoFissoValidation()"></p>
				</div>
			</div>
		</form>
	</ng-template>
</div>